import ImgIcon from "@/components/ImgIcon.vue";
import { defineComponent } from "vue";
import { useI18n } from "vue-i18n";
export default defineComponent({
  name: "NavComponent",
  data: function data() {
    return {
      isActive: false
    };
  },
  components: {
    ImgIcon: ImgIcon
  },
  watch: {
    $route: function $route(newRoute, oldRoute) {
      if (newRoute.path != oldRoute.path && oldRoute.href) {
        this.isActive = false;
      }
    }
  },
  setup: function setup() {
    return useI18n();
  }
});